export enum CarouselItemPositionEnum {
	left = 'left',
	right = 'right',
	center = 'center',
	void = 'void'
}
